import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChatIcon, StorefrontIcon } from '@yonderland/andes-icons';
import { Icon, LinkButton } from '@yonderland/andes-react';
const ICONS_MAPPING = {
    stores: StorefrontIcon,
    help: ChatIcon,
    support: ChatIcon,
};
const QuickLinksItem = ({ linkKey, linkName, linkPath }) => {
    const handleClick = linkPath
        ? () => {
            window.location.href = linkPath;
        }
        : undefined;
    return (_jsxs(LinkButton, { testId: linkKey, theme: "neutral", variant: "tertiary", size: "sm", onClick: handleClick, children: [ICONS_MAPPING[linkKey] && _jsx(Icon, { size: "sm", source: ICONS_MAPPING[linkKey] }), linkName] }));
};
export default QuickLinksItem;
